import Api from 'services/Api';
import type { AppDispatch } from '../../../../store';
import { AT } from './actionTypes';

export const subscribe = {
  type: AT.WS_SUBSCRIBE._,
  payload: {}
};

export const unsubscribe = {
  type: AT.WS_UNSUBSCRIBE._,
  payload: {}
};

export const getVerificationDocuments = () => (dispatch: AppDispatch) =>
  Api.actions.kyc.verificationDocuments()(dispatch);
